<template>
    <div
        class="track-trip-counter"
        :class="borderedClass"
    >
        <div
            class="track-trip-counter__item"
            :class="columnClass"
        >
            {{ timer.days }}<span class="track-trip-counter__item-text">дн.</span>
        </div>
        <div
            class="track-trip-counter__item"
            :class="columnClass"
        >
             {{ timer.hours }}<span class="track-trip-counter__item-text">час.</span>
        </div>
        <div
            class="track-trip-counter__item"
            :class="columnClass"
        >
            {{ timer.minutes }} <span class="track-trip-counter__item-text">мин.</span>
        </div>
        <div
            class="track-trip-counter__item"
            :class="columnClass"
        >
            {{ timer.seconds }} <span class="track-trip-counter__item-text">сек.</span>
        </div>
    </div>
</template>

<script>
export default{
    name: 'TrackTripCounter',
    data: () => ({
        timer: {
            days: '',
            hours: '',
            minutes: '',
            seconds: '',
            expired: false,
        },
    }),
    props: {
        bordered: {
            type: Boolean,
        },
        columnMode: {
            type: Boolean,
        },
        expiration: {
            type: String,
        },
    },
    computed: {
        borderedClass() {
            return this.bordered ? ' track-trip-counter_mode_bordered' : '';
        },
        columnClass() {
            return this.columnMode ? ' track-trip-counter__item_mode_column' : '';
        },
    },
    created() {
        let self = this;
        let initCounter = setInterval(function(){
            let countDownDate = new Date(self.expiration).getTime();
            let now = new Date().getTime();
            let diff = countDownDate - now;
        
            let tdays = Math.floor(diff / (1000 * 60 * 60 * 24));
            let thours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let tminutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            let tseconds = Math.floor((diff % (1000 * 60)) / 1000);
        
            self.timer.days = (tdays < 10) ? tdays : tdays;
            self.timer.hours = (thours < 10) ? thours : thours;
            self.timer.minutes = (tminutes < 10) ? '0' + tminutes : tminutes;
            self.timer.seconds = (tseconds < 10) ? '0' + tseconds : tseconds;
    
            if(diff < 0){
                clearInterval(initCounter);
                self.timer.expired = true;
            }
        }, 1000);

        return {
            days: self.timer.days,
            hours: self.timer.hours,
            minutes: self.timer.minutes,
            seconds: self.timer.seconds,
        };
    },
};
</script>

<style lang="scss" scoped>
    @import '@/styles/rem';
    @import '@/styles/mrem';

    $defaultColor: #713DD3;

    .track-trip-counter {
        width: mrem(330);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: mrem(11) mrem(15);
        margin-bottom: mrem(16);
        background: #fff;
        border-radius: 4px;

        &_mode{
            &_bordered {
                border: 2px solid $defaultColor;
                border-radius: 7px;
            }
        }

        @include on-desktop {
            width: rem(330);
            padding: rem(11) rem(15);
            margin-bottom: rem(16);
        }

        &__item {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            width: mrem(77);
            font-size: mrem(24);
            line-height: mrem(26);
            color: $defaultColor;

            &_mode{
                &_column {
                    flex-direction: column;
                    font-size: mrem(42);
                    line-height: mrem(36);
                    text-transform: uppercase;
                }
            }

            @include on-desktop {
                font-size: rem(24);
                line-height: rem(26);
                &_mode{
                    &_column {
                        flex-direction: row;
                        font-size: rem(42);
                        line-height: rem(46);
                        align-items: baseline;

                        .track-trip-counter__item-text {
                            font-size: rem(24);
                        }
                    }
                }
            }
        }

        &__item-text {
            font-weight: normal;
            margin-left: mrem(4);
            font-size: mrem(18);

            @include on-desktop {
                margin-left: rem(4);
                font-size: rem(18);
            }
        }
    }
</style>

